import { create } from 'zustand';

/** 高级设置
 * 1. 节点选择器
 * 2. 元数据
 *    - 节点 指定节点 对应 metadata.annotations
 *    - 元数据 元数据 对应 metadata.labels
 */
export enum NodeType {
  NODE = 'Node',
  META = 'Meta',
}

export interface NodeSelectorItem {
  key: string;
  value: string;
  type?: NodeType;
}

export interface AnnotationMetadataItem {
  key: string;
  value: string;
}

export interface NodesAndMetaDataState {
  nodeSelector: NodeSelectorItem[];
  annotationMetadata: AnnotationMetadataItem[];
}

const initialState: NodesAndMetaDataState = {
  nodeSelector: [],
  annotationMetadata: [],
};

interface NodesAndMetaDataAction {
  updateNodeSelector: (nodeSelector: NodeSelectorItem[]) => void;
  updateMetadata: (metadata: AnnotationMetadataItem[]) => void;
  reset: () => void;
}

export const useNodesAndMetadataStore = create<NodesAndMetaDataState & NodesAndMetaDataAction>()(
  (set) => ({
    ...initialState,
    updateNodeSelector: (nodeSelector) => set({ nodeSelector }),
    updateMetadata: (metadata) => set({ annotationMetadata: metadata }),
    reset: () => set(initialState),
  }),
);
